<template>
  <v-dialog :value="value" width="1100" @click:outside="close">

    <AuditTable :items="getProductAuditHistory.logs" :loading="getProductAuditHistoryLoading" :server-items-length="getProductAuditHistory.config.paginationCount" @updatePagination="updatePagination" :reset="resetAuditTable">
      <template #title>Product Audit</template>
    </AuditTable>

  </v-dialog>
</template>

<script>
  import { mapMutations, mapActions, mapGetters } from 'vuex';

  import AuditTable from '@/components/Globals/AuditTable';

  export default {
    components: { AuditTable },

    props: ['value'],

    data() {
      return {
        resetAuditTable: false
      }
    },

    computed: {
      ...mapGetters('products', ['getCurrentProduct', 'getProductAuditHistory', 'getProductAuditHistoryLoading']),
    },

    watch: {
      value(open) {
        if (open) {
          this.resetAuditTable = false;
          this.fetchProductAudit(this.getCurrentProduct.id);
        }
      }
    },

    methods: {
      ...mapMutations('products', ['RESET_PRODUCT_AUDIT_HISTORY']),
      ...mapActions('products', ['fetchProductAudit', 'updateProductAuditPagination']),

      updatePagination(options) {
        this.updateProductAuditPagination({ productId: this.getCurrentProduct.id, options });
      },

      resetTable() {
        this.resetAuditTable = true;
        this.RESET_PRODUCT_AUDIT_HISTORY();
      },

      close() {
        this.resetTable();     
        this.$emit('input', false);
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>